import type React from "react";
import { ReactComponent as Svg } from "./assets/single-neutral-circle.svg";
import * as styles from "./Icon.module.scss";

type ProfileProps = React.SVGProps<SVGSVGElement>;

export const Profile = ({ className, ...props }: ProfileProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
